import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RMSRecordReviewService } from '../../../../shared/services/rmsRecordReview.service';
import { IThreatAssessmentTeam } from '../../../../shared/models/contact';
import { ContactsService } from '../../../../shared/services/contact.service';
import { UserDataService } from '../../../../shared/services/auth/userData.service';

@Component({
  selector: 'review-rms-record-of-review',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-rms-record-of-review.component.html',
  styleUrl: './review-rms-record-of-review.component.css'
})
export class ReviewRmsRecordOfReviewComponent implements OnInit {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  rmsRecordOfReview: any | null = null;
  usersList: IThreatAssessmentTeam[] = [];
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  userFillingForm: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Reviewer Information",
      children: [
        {
          type: 'string',
          questionText: "Person filling out form:",
          answer: "user_filling_form_fullname"
        },
        {
          type: 'date',
          questionText: "Form date started:",
          answer: "date_started"
        },
        {
          type: 'string',
          questionText: "Form time started:",
          answer: "time_started"
        }
      ]
    },
    {
      sectionName: "Review of Response, Management, and Support (RMS) Plan",
      children: [
        {
          type: 'date',
          questionText: "Review Date:",
          answer: "review_date"
        },
        {
          type: 'string',
          questionText: "Progress Notes:",
          answer: "progress_notes"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "date_timetime_signed"
        }
      ]
    }
  ];

  constructor(
    private userDataService: UserDataService,
    private rmsRecordReviewService: RMSRecordReviewService,
    private contactsService: ContactsService
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.loadRmsRecordReview();
  }

  loadRmsRecordReview(): void {
    if (this.caseId) {
      this.loading = true;      
      this.rmsRecordReviewService.getRmsRecordReviewByCaseId(this.caseId).subscribe({
        next: (response) => {
          this.rmsRecordOfReview = response;
          this.loading = false;
          this.loadUsers();
        },
        error: (error) => {
          console.error('Error fetching RMS Record of Review:', error);
          this.loading = false;
        }
      });
    }
  }

  // load all Users
  loadUsers(): void {
    this.loading = true;
    this.contactsService.getUsers(this.currentBuildingId!).subscribe({
      next: (users: IThreatAssessmentTeam[]) => {
        this.usersList = users;
        if (this.usersList.length > 0) {
          this.userFillingForm = this.usersList.find(contact => contact.user_id === Number(this.rmsRecordOfReview.user_filling_form_id)) || null;
        }
        this.loading = false;
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Error loading users:', error.message);
      }
    });
  };

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
